import React from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import get from 'lodash/get';

import { connect } from 'react-redux';

import './styles.css';
import Dropdown from '../Dropdown';
import Button from '../Button';
import Icon from '../Icon';
import {
  addBasicInfoFieldData as addBasicInfoFieldDataAction,
  removeBasicInfoFieldData as removeBasicInfoFieldDataAction,
} from '../../containers/CollegeProfileReact/BasicInfo/actions';

export class HubsEntityCollectionComponent extends React.Component {
  static propTypes = {
    collection: PropTypes.object.isRequired,
    keyName: PropTypes.string,
    _nonUniqueKeyValues: PropTypes.string,
    _key: PropTypes.string.isRequired,
    nonUnique: PropTypes.bool,
    _allowedKeyValues: PropTypes.array,
    _disabledKeyValues: PropTypes.array,
    children: PropTypes.object,
    disableRemove: PropTypes.bool,
    initialValue: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]).isRequired,
    mapper: PropTypes.object,
    addBasicInfoFieldData: PropTypes.func,
    removeBasicInfoFieldData: PropTypes.func,
    fieldName: PropTypes.string,
    entityGroup: PropTypes.string,
  };

  state = {
    activeEntity: null,
    possibleValuesForKey: null,
    addKey: null,
  };

  componentWillMount = () => {
    this.generatePossibleValuesForKey();
  }

  add = () => {
    const { addKey } = this.state;
    const { fieldName, addBasicInfoFieldData, collection, initialValue, entityGroup } = this.props;

    if (addKey !== null) {
      const values = {};
      values[`field_${this.props._key}`] = [{ value: addKey }];
      const newEntity = collection.addEntity(values);

      addBasicInfoFieldData({
        fieldName,
        value: {
          ...Object.keys(this.props.mapper).reduce((o, param) => Object.assign(o, { [param]: '' }), {}),
          eid: newEntity.getField().eid,
          type: addKey,
          typeName: get(collection, 'editor.cmsDataMapping.deadlineTypes', {})[addKey],
        },
        fieldKey: entityGroup,
      });

      this.setState({ activeEntity: initialValue.length });
    }
    this.generatePossibleValuesForKey();
    this.setState({ addKey: null });
  }

  getKeyValue(id) {
    const metadata = this.props.collection.getFieldMetadata(`field_${this.props._key}`);
    const value = metadata.allowed_values[id];
    if (value != null) {
      return value;
    }
    return id;
  }

  remove = (entity, order) => {
    const { collection, removeBasicInfoFieldData, fieldName } = this.props;

    collection.removeEntity(entity);
    removeBasicInfoFieldData({
      fieldName,
      order,
    });
    this.generatePossibleValuesForKey();
  }

  generatePossibleValuesForKey = () => {
    const metadata = this.props.collection.getFieldMetadata(`field_${this.props._key}`);
    let disabledKeys = this.props._disabledKeyValues;
    if (!this.props.nonUnique) {
      disabledKeys = this.props.collection.getEntities()
        .map((e) => e.getField(this.props._key).getValue())
        .filter((id) => !this.props._nonUniqueKeyValues || !includes(this.props._nonUniqueKeyValues, id))
        .concat(disabledKeys);
    }
    const possibleValuesForKey = Object.keys(metadata.allowed_values)
      .filter((id) => !includes(disabledKeys, id))
      .filter((id) => !this.props._allowedKeyValues || includes(this.props._allowedKeyValues, id))
      .map((id) => ({ id, label: metadata.allowed_values[id] }));
    this.setState({ possibleValuesForKey });
  }

  toggle = (order) => {
    if (this.state.activeEntity === order) {
      this.setState({ activeEntity: null });
    } else {
      this.setState({ activeEntity: order });
    }
  };

  onSelect = (e, data) => {
    const { value } = data;
    const { key } = data.options.find((o) => o.value === value);
    this.setState({ addKey: key });
  }

  render() {
    const { activeEntity, possibleValuesForKey } = this.state;
    const { keyName, disableRemove, collection, entityGroup, initialValue } = this.props;
    const possibleValues = possibleValuesForKey.map((item) => ({ key: item.id, value: item.label, text: item.label }));

    const entities = entityGroup ? initialValue[entityGroup] : initialValue;
    return (
      <React.Fragment>
        <div>
          <div>
            { entities.map((entity, order) => (
              entity && (
              <div styleName="entity-collection__item" key={entity.eid} data-cy={`PremiumHem-List-Entity-${this.getKeyValue(entity.type)}`}>
                <div styleName="entity-collection__heading">
                  <strong
                    onClick={() => this.toggle(order)}
                    styleName="entity-collection__name"
                    title=""
                    role="link"
                    tabIndex={0}
                    onKeyPress={() => this.toggle(order)}
                  >
                    { this.getKeyValue(entity.type) }
                  </strong>
                  { !disableRemove && (
                    <Button icon basic onClick={() => this.remove(entity, order)} title="Remove item">
                      <Icon name="minus" />
                    </Button>
                  )}
                </div>
                { activeEntity === order && (
                  React.Children.map(this.props.children, (child) =>
                    React.cloneElement(child, { entity, order, collection }))
                )}
              </div>
              )
            ))}
          </div>
          { possibleValuesForKey.length ? (
            <div styleName="entity-collection__add">
              <div>
                {keyName && <label htmlFor="field-{{ ::vm.collection.htmlId }}-key" className="hem-label">Add new item</label>}
                <Dropdown selection options={possibleValues} onChange={this.onSelect} data-cy="Premium-Hem-New-Entity-Input" />
              </div>
              <div styleName="entity-collection__add-right">
                <Button icon basic onClick={this.add} title="Add new item" id="addItem">
                  <Icon name="plus" />
                </Button>
              </div>
            </div>
          ) : null }
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  basicInfo: get(
    state,
    'basicInfo',
  ),
});

export default connect(
  mapStateToProps, {
    addBasicInfoFieldData: addBasicInfoFieldDataAction,
    removeBasicInfoFieldData: removeBasicInfoFieldDataAction,
  },
)(HubsEntityCollectionComponent);
